module.exports = __webpack_public_path__ + "img/35642a2.jpg";